// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e6be3412","551":"f43ad513","667":"27f743fb","977":"add3d230"}[chunkId] + ".chunk.js";
};